/**
 * Detects system-generated placeholder emails (e.g. 12345@livelaps.com).
 * These are auto-assigned to users who registered without a real email.
 */
export function isLivelapsEmail(email) {
  if (!email || typeof email !== 'string') return false;
  return /^\d+@livelaps\.com$/i.test(email.trim());
}
